import { GridBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/gridBlock/gridBlock'
import { onlyNumbers } from '@shared/Frontend/utils/numbers'
import { slugify } from '@shared/Frontend/utils/slugify'
import * as React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { CMSState, Id, ImageSize, Link } from '../types.gen'

export type LinkGridBlockProps = {
  index: number
  background: string
  title?: string
  intro?: string
  items: LinkGridItem[]
  link?: Link
  show_image: 'yes' | 'no'
  get_default_data_src: () => ImageSize
  get_default_data_srcset: () => [ImageSize, string][]
}

export type LinkGridItem = {
  image: Id
  image_size: ImageSize
  image_alt: string
  title: string
  label?: string
  intro: string
  link?: Link
  show_image: 'yes' | 'no'
}

export function LinkGridBlock(
  props: LinkGridBlockProps
): (
  viewportWidth: number,
  cmsState: CMSState
) => Widget<Updater<CMSState>> {
  return (viewportWidth, cmsState) =>
    fromJSX(() => {
        const imageSrc = (img: number) => {
          const image = cmsState.images.get(img)
          // We know this is always loaded, see `image_utils.mod.ts`
          if (image.kind != 'loaded') {
            throw new Error(
              `Image with id ${image} is not loaded yet. Ensure that the image is loaded before accessing its value.`
            )
          }
          return image.value
        }

        return (
          <GridBlockLayout
            id={slugify(props.title)}
            variant={props.items.every((item) => item.show_image === 'yes') ? 'image' : 'text'}
            bgColour={props.background == 'grey' ? 'grey' : 'white'}
            title={props.title}
            intro={props.intro}
            primaryUpdater={
              props.link
                ? {
                    ...props.link,
                    isExternal: props.link.is_link_external
                  }
                : undefined
            }
            items={props.items.map((item) => ({
              title: item.title,
              intro: item.intro,
              label: item.label,
              link: item.link
                ? {
                    ...item.link,
                    isExternal: item.link.is_link_external
                  }
                : undefined,
              image: item.image
                ? {
                    alt: item.image_alt,
                    src: imageSrc(item.image).get(props.get_default_data_src()),
                    crops: props.get_default_data_srcset().map(([ url, width ]) => ({
                      url: imageSrc(item.image).get(url),
                      width: Number(onlyNumbers(width))
                    }))
                  }
                : undefined
            }))}
            enableCarousel
            viewportWidth={viewportWidth}
          />
        )
      }
    )
}
